import React, { useState, useEffect } from 'react';
import Lottie from 'lottie-react';

const slides = [
  {
    title: '24x7 PAYMENTS',
    description:
      "Welcome to 24 Pay, where we're dedicated to revolutionizing financial solutions around the clock. With a keen focus on providing the ultimate reliable payment solutions, we're committed to providing 24x7 support to various segments of the Indian economy.",
  },
  {
    title: 'SECURE TRANSACTIONS',
    description:
      'Bank-grade security ensures your transactions are protected with advanced encryption and fraud detection. Our multi-layer security system provides peace of mind for all your financial activities.',
  },
  {
    title: 'INSTANT PAYMENTS',
    description:
      'Experience lightning-fast payment processing with our cutting-edge technology. Send and receive money instantly across India with our robust payment infrastructure.',
  },
];

const AuthLayout = ({ title, subtitle, children, onBack }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [animationData, setAnimationData] = useState(null);

  const changeSlide = (direction) => {
    const totalSlides = slides.length;
    if (direction === 1) {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    } else {
      setCurrentSlide((prev) => (prev - 1 + totalSlides) % totalSlides);
    }
    setIsPaused(true);
  };

  const handleSlideClick = (slideIndex) => {
    setCurrentSlide(slideIndex);
    setIsPaused(true);
  };

  useEffect(() => {
    if (isPaused) return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [isPaused]);

  useEffect(() => {
    if (isPaused) {
      const resumeTimer = setTimeout(() => {
        setIsPaused(false);
      }, 10000);
      return () => clearTimeout(resumeTimer);
    }
  }, [isPaused]);

  useEffect(() => {
    fetch('/Successcelebration.json')
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((error) => console.error('Error loading animation:', error));
  }, []);

  return (
    <div className="login-page-container">
      <div className="login-card">
        <div className="illustration-section">
          <div className="illustration-content">
            <div className="simple-illustration">
              <div className="main-icon">
                <i className="fas fa-credit-card"></i>
              </div>
              <div className="service-icons">
                <div className="service-icon">
                  <i className="fas fa-mobile-alt"></i>
                </div>
                <div className="service-icon">
                  <i className="fas fa-university"></i>
                </div>
                <div className="service-icon">
                  <i className="fas fa-money-bill-wave"></i>
                </div>
                <div className="service-icon">
                  <i className="fas fa-bolt"></i>
                </div>
              </div>
            </div>

            <div className="slides-container">
              {slides.map((slide, index) => (
                <div
                  key={slide.title}
                  className={`slide ${currentSlide === index ? 'active' : ''}`}
                >
                  <h2 className="illustration-title">{slide.title}</h2>
                  <p className="illustration-subtitle">{slide.description}</p>
                </div>
              ))}
            </div>

            <div className="slide-navigation">
              <button className="nav-btn prev-btn" onClick={() => changeSlide(-1)}>
                <i className="fas fa-chevron-left"></i>
              </button>
              <div className="pagination-dots">
                {slides.map((_, index) => (
                  <div
                    key={index}
                    className={`dot ${currentSlide === index ? 'active' : ''}`}
                    onClick={() => handleSlideClick(index)}
                  ></div>
                ))}
              </div>
              <button className="nav-btn next-btn" onClick={() => changeSlide(1)}>
                <i className="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', flex: '1 1 0%' }}>
          {onBack && (
            <div
              className="auth-top-bar"
              style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                marginBottom: '1rem',
                marginLeft: '1rem',
                marginTop: '0.5rem'
              }}
            >
              <button
                type="button"
                onClick={onBack}
                className="auth-back-button"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  background: '#f1f5f9',
                  border: 'none',
                  color: '#0f172a',
                  fontSize: '1rem',
                  cursor: 'pointer',
                  boxShadow: '0 2px 6px rgba(15, 23, 42, 0.12)'
                }}
                aria-label="Go back"
              >
                <i className="fas fa-arrow-left"></i>
              </button>
            </div>
          )}

          <div className="login-form-section">
            <div className="login-form-container">
              <div className="lottie-animation-container">
                {animationData && (
                  <Lottie
                    animationData={animationData}
                    loop={true}
                    autoplay={true}
                    style={{ width: 180, height: 180 }}
                  />
                )}
              </div>

              <div className="login-header">
                <div className="brand-logo">
                  <img
                    src="/24-pay-logo.svg"
                    alt="24 Pay Logo"
                    className="company-logo"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const fallback = e.target.nextElementSibling;
                      if (fallback) fallback.style.display = 'block';
                    }}
                  />
                  <div className="company-logo-text" style={{ display: 'none' }}>
                    <span className="brand-text">24 Pay</span>
                  </div>
                </div>
              </div>

              <div className="login-form-content">
                {title && <h2 className="login-title">{title}</h2>}
                {subtitle && <p className="login-subtitle">{subtitle}</p>}
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;


